export const Pages = [
    { path: `/`, name: `الرئيسية`, name_en: `Home` },
    { path: `about`, name: `من نحن`, name_en: `About Us` },
    { path: `agencies`, name: `وكالاتنا`, name_en: `Our Agencies` },
    { path: `contact`, name: `تواصل معنا`, name_en: `Contact Us` },
];
